import { createAction } from '@reduxjs/toolkit';

export const getPadChoicesFromHDMS = createAction('API_FETCH_HDMS_PAD_CHOICES');
export const updateFetchedPadChoices = createAction('UPDATE_FETCHED_PAD_CHOICES');
export const setSelectedCarpetPad = createAction('SET_SELECTED_CARPET_PAD');
export const removePreselectionFlag = createAction('REMOVE_PRESELECTION_FLAG');